import { render, staticRenderFns } from "./minicrud_combobox.vue?vue&type=template&id=4500ca0a&lang=pug&"
import script from "./minicrud_combobox.vue?vue&type=script&lang=js&"
export * from "./minicrud_combobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports